import React, { useState } from 'react'
import { t } from '../../../i18n'
import ConfirmModal from './ConfirmModal'
import submitNavigationForm from './submitNavigationForm'
import { VersioningActions } from './types'

interface VersionActionsBarProps {
  actions?: VersioningActions
  readOnly: boolean
  submitting: boolean
  formId: string
  indexHref: string
  deleteDraftUrl?: string
  createNewVersionUrl?: string
  deleteConfirmBody?: string
  onPublish: () => void
  children?: React.ReactNode
}

const VersionActionsBar = ({
  actions,
  readOnly,
  submitting,
  formId,
  indexHref,
  deleteDraftUrl,
  createNewVersionUrl,
  deleteConfirmBody,
  onPublish,
  children
}: VersionActionsBarProps) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  return (
    <>
      <div>
        {actions?.canDeleteDraft && deleteDraftUrl && (
          <button
            type="button"
            className="btn btn-danger inverted me-2"
            onClick={() => setShowDeleteConfirm(true)}
          >
            {t('versioning.delete_draft')}
          </button>
        )}
        <a className="btn btn-secondary inverted me-2" href={indexHref}>
          {t('cancel')}
        </a>
        {actions?.canCreateNewVersion && createNewVersionUrl && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => submitNavigationForm(createNewVersionUrl, 'post')}
          >
            {t('versioning.create_new_version')}
          </button>
        )}
        {!readOnly && children}
        {!readOnly && (
          <button
            type="submit"
            form={formId}
            className="btn btn-secondary me-2"
            disabled={submitting}
          >
            {t('save')}
          </button>
        )}
        {actions?.canPublish && (
          <button
            type="button"
            className="btn btn-primary"
            disabled={submitting}
            onClick={onPublish}
          >
            {t('versioning.save_and_publish')}
          </button>
        )}
      </div>
      {showDeleteConfirm && deleteDraftUrl && (
        <ConfirmModal
          title={t('versioning.delete_draft_confirm_title')}
          confirmActions={[
            {
              label: t('versioning.delete_draft'),
              className: 'btn btn-danger',
              onConfirm: () => submitNavigationForm(deleteDraftUrl, 'delete')
            }
          ]}
          onClose={() => setShowDeleteConfirm(false)}
        >
          <p className="mb-0">
            {deleteConfirmBody ?? t('versioning.delete_draft_confirm_body')}
          </p>
        </ConfirmModal>
      )}
    </>
  )
}

export default VersionActionsBar
